import _ from 'lodash';

import { xml2json } from '../../form-designer/utils/runtime.utils';

export const validateConfigDatasourcXml = ({ xml }) => {
  const parsedJson = xml2json(xml);
  const { DataSource } = parsedJson?.root ?? {};

  if (!DataSource) {
    throw new Error('Invalid Import File Format');
  }

  // Normalize DataSource to be an array
  const dataSources = Array.isArray(DataSource) ? DataSource : [DataSource];

  const invalidConfigdatasources = dataSources
    .map((dataSource, index) => {
      if (
        _.isNil(dataSource.Id) ||
        _.isNil(dataSource.Source) ||
        _.isNil(dataSource.Description) ||
        _.isNil(dataSource.Query) ||
        _.isNil(dataSource.SelectValueColumns)
      ) {
        return index + 1; // return 1-based index of the invalid setting
      }
    })
    .filter((index) => index !== undefined); // filter out valid settings

  if (invalidConfigdatasources.length > 0) {
    throw new Error('Invalid Import File Format');
  }

  return dataSources;
};

export const extractRowsForPayload = (rows, initialRows) => {
  const differingRows = [];

  rows.forEach((row1) => {
    const row2 = initialRows.find((row) => row.id === row1.id && row.source === row1.source);
    if (!row2 || JSON.stringify(row1) !== JSON.stringify(row2)) {
      differingRows.push(row1);
    }
  });

  return differingRows;
};
